import { Validation, ValidationTypes } from "../../../validation/constants";
import { isValidDate } from "../../../utilities/date";

const VALIDATIONS_WEEK: Array<Validation> = [
  {
    type: ValidationTypes.ERROR,
    message: "dateEntity.errors.invalidWeek",
    icon: "ExclamationCircle",
    requiresValue: true,
    validate: isValidDate,
  },
];

export default VALIDATIONS_WEEK;
